import axios from 'axios';

const apiClient = axios.create({
  baseURL: '/',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
});

// 請求攔截器：自動加入 Access Token (JWT) 或 CSRF Token
apiClient.interceptors.request.use(
  (config) => {
    const accessToken = sessionStorage.getItem('access_token');

    // 對於 API 請求，使用 JWT
    if (accessToken && config.url?.startsWith('/api/v1/')) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    // 對於傳統請求，使用 CSRF Token
    else if (!config.url?.startsWith('/api/v1/')) {
      const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
      if (csrfToken) {
        config.headers['X-CSRF-Token'] = csrfToken;
      }
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// 回應攔截器：自動刷新 Token
apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // 只對 API 請求進行 Token 刷新
    if (error.response?.status === 401 &&
        !originalRequest._retry &&
        originalRequest.url?.startsWith('/api/v1/')) {
      originalRequest._retry = true;

      try {
        // 使用 Refresh Token 刷新
        await axios.post('/api/v1/users/token/refresh', null, {
          withCredentials: true  // 確保發送 HttpOnly Cookie
        });

        const accessToken = sessionStorage.getItem('access_token');
        originalRequest.headers.Authorization = `Bearer ${accessToken}`;
        return apiClient(originalRequest);
      } catch (refreshError) {
        // Refresh Token 失效，導向登入頁
        sessionStorage.removeItem('access_token');
        window.location.href = '/users/sign_in';
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default apiClient;
